import apiClient from './authService';

// Property service using shared apiClient (injects auth token & baseURL)
export const propertyService = {
  getAll: async () => {
    const response = await apiClient.get('/api/properties');
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/api/properties/${id}`);
    return response.data;
  },

  create: async (propertyData) => {
    const response = await apiClient.post('/api/properties', propertyData);
    return response.data;
  },

  update: async (id, propertyData) => {
    const response = await apiClient.put(`/api/properties/${id}`, propertyData);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/api/properties/${id}`);
    return response.data;
  }
};
